
export const FILTER_GROUP_TYPE_DEFAULT_COLLECTION = "DEFAULT_COLLECTION";
export const FILTER_GROUP_TYPE_SEARCH = "SEARCH_RESULT";
export const FILTER_GROUP_TYPE_COLLECTION = "COLLECTION";
export const FILTER_GROUP_TYPE_VENDOR = "VENDOR";
